// extracted by mini-css-extract-plugin
module.exports = {"UseCaseCard":"UseCaseCard_UseCaseCard__3fSHn","Button":"UseCaseCard_Button__1K2DN","Logo":"UseCaseCard_Logo__3tGXu","Title":"UseCaseCard_Title__10x0e"};